import type { ReactNode } from "react";
import Radio from "./Radio";
import Avatar from "../Avatar";
import Tag from "../Tag";
import type { TagType } from "../Tag/Tag";
import classNames from "classnames";

export interface RadioCardProps {
  headline: ReactNode;
  supportingText?: string;
  onChange: (value: boolean) => void;
  checked: boolean;
  name: string;
  disabled?: boolean;
  testId?: string;
  picture?: string;
  useAvatar?: boolean;
  tagText?: string;
  tagType?: TagType;
}

export default function RadioCard({
  headline,
  supportingText,
  onChange,
  checked,
  disabled = false,
  name,
  testId,
  picture,
  useAvatar: useAvatarProp = false,
  tagText,
  tagType = "information"
}: RadioCardProps) {
  const showAvatar = useAvatarProp || !!picture;

  return (
    <div
      data-testid={testId}
      className={classNames("rounded-xl border p-5 transition-colors", {
        "border-sys-brand-primary bg-sys-brand-surface-container-lowest": checked,
        "border-sys-brand-outline-variant bg-sys-brand-surface": !checked,
        "cursor-pointer": !disabled
      })}
      onClick={() => !disabled && !checked && onChange(true)}
    >
      <div className="flex items-center gap-4">
        <Radio
          label={headline}
          supportingText={supportingText}
          name={name}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
        />
        {tagText && (
          <Tag tagType={tagType} size="small">
            {tagText}
          </Tag>
        )}
        {showAvatar && <Avatar picture={picture} className="w-10 h-10 flex-shrink-0" />}
      </div>
    </div>
  );
}
